<template>
	<div class="container">
		<div class="mainPage" id="page0">
			<Navigation />
			<div id="welcome">
				<h1>Conscius</h1>
				<p class="slogan">Bedrijfsrevisoren met oog voor detail</p>
				<router-link :to="{ name:'contact' }">
					<a href="#" class="buttonPrimary button">contacteer ons</a>
				</router-link>
				<!-- <router-link :to="{ name:'visie' }">
					<a href="#" class="buttonSecondary button">onze visie</a>
				</router-link> -->
				<a @click="scrollTo('page1')" class="scrollNext">
					<p>Ontdek onze troeven</p>
					<i class="fas fa-angle-down"></i>
				</a>
			</div>
		</div>
		<div class="pageRight" id="page1">
			<div class="image image1"></div>
			<div class="infoRight">
				<div class="number">
					<p>1</p>
				</div>
				<div class="infoText">
					<h2>Mandaten</h2>
					<p>Het uitvoeren van commissarismandaten.</p>
				</div>
			</div>
			<a @click="scrollTo('page2')" class="scrollNext">
				<p>Volgende</p>
				<i class="fas fa-angle-down"></i>
			</a>
		</div>
		<div class="pageLeft" id="page2">
			<div class="image image2"></div>
			<div class="infoLeft">
				<div class="number">
					<p>2</p>
				</div>
				<div class="infoText">
					<h2>Bijzondere opdrachten</h2>
					<p>Bijzondere opdrachten in samenwerking met de financieel directeur of eerstelijnsadviseur.</p>
				</div>
			</div>
			<a @click="scrollTo('page3')" class="scrollNext">
				<p>Volgende</p>
				<i class="fas fa-angle-down" ></i>
			</a>
		</div>
		<div class="pageRight" id="page3">
			<div class="image image3"></div>
			<div class="infoRight">
				<div class="number">
					<p>3</p>
				</div>
				<div class="infoText">
					<h2>Transaction services</h2>
					<p>Ondernemingen die op het punt staan worden verkocht&sol;gekocht, begeleiden vanaf de waardering tot overlating&sol;overname.</p>
				</div>
			</div>
			<a @click="scrollTo('page4')" class="scrollNext">
				<p>Volgende</p>
				<i class="fas fa-angle-down"></i>
			</a>
		</div>
		<div class="pageLeft" id="page4">
			<div class="image image4"></div>
			<div class="infoLeft">
				<div class="number">
					<p>4</p>
				</div>
				<div class="infoText">
					<h2>Financial management services</h2>
					<p>Het bijstaan van ondernemingen die tijdelijk of permanent expertise nodig hebben op vlak van interne audit en administratieve organisatie, controlling, corporate &amp; finance, ...</p>
				</div>
			</div>
			<a @click="scrollTo('page0')" class="scrollNext scrollBack">
				<p>Terug naar boven</p>
				<i class="fas fa-angle-up"></i>
			</a>
		</div>
		<Footer />
	</div>
</template>

<script>
	import Navigation from '../components/Navigation.vue'
	import Footer from '../components/Footer.vue'

	export default {
		name: 'Home',
		components: {
			Navigation,
			Footer,
		},
		methods: {
			scrollTo: function(divId) {
				let div = document.getElementById(divId);
				scrollTo(document.body, div.offsetTop, 100);
			}
		}
	}

</script>

<style lang="scss" scoped>
  @import '../sass/home.scss';
</style>
